import { orReducer } from "./orReducer";
import type { AppPaneUnderlayViewState } from "../store/schema/AppPaneUnderlayViewState";
import getStore from "../store/store";

export default function isAppPaneUnderlayShrinkable(underlay?: AppPaneUnderlayViewState): boolean | undefined {
    const store = underlay || getStore();
    return [...store.shrinkable.values()].reduce(orReducer, false);
}
